/* ============================================================
   Page collection — chargement de toutes les pages en tâche de fond,
   filtres à facettes (valeur faciale, pays, qualité, millésime),
   tri, regroupement par année, « Afficher plus », état dans l'URL.

   Principe : chaque carte porte ses métachamps en data-* ; la page
   courante est rendue par Shopify, les autres pages sont lues via la
   vue alternative ?view=cartes&page=n (templates/collection.cartes.liquid).
   Toute la logique de tri / filtrage est dans collection-core.js.
   Sans JavaScript : page courante + pagination classique.
   ============================================================ */
(function () {
  'use strict';

  var C = window.MDMCollection;
  if (!C || window.__mdmCollectionUI) return;
  window.__mdmCollectionUI = true;

  var NS_SVG = 'http://www.w3.org/2000/svg';
  var NOMS_FACETTES = { valeur: 'libValeur', pays: 'libPays', qualite: 'libQualite', annee: 'libAnnee' };

  function lireJSON(el) {
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  function remplacer(modele, valeurs) {
    return String(modele || '').replace(/\{(\w+)\}/g, function (m, k) { return valeurs[k] != null ? valeurs[k] : m; });
  }
  function el(tag, classe, attrs) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }
  function svg(chemin, w, h, classe) {
    var s = document.createElementNS(NS_SVG, 'svg');
    s.setAttribute('width', w); s.setAttribute('height', h);
    s.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.6'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    if (classe) s.setAttribute('class', classe);
    var p = document.createElementNS(NS_SVG, 'path');
    p.setAttribute('d', chemin);
    s.appendChild(p);
    return s;
  }
  var estMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function Collection(racine) {
    var cfg = lireJSON(racine.querySelector('[data-coll-config]'));
    var hote = racine.querySelector('[data-grille]');
    if (!hote) return;
    var outils = racine.querySelector('[data-outils]');
    var lib = outils ? outils.dataset : {};
    var modeles = racine.querySelector('[data-modeles]');
    var modeleAnnee = modeles && modeles.querySelector('[data-modele-annee]');
    var modeleType = modeles && modeles.querySelector('[data-modele-type]');
    var titresAnnee = !modeles || modeles.dataset.titresAnnee !== '0';
    var sousTitres = !!modeles && modeles.dataset.sousTitres === '1';
    var zoneFiltres = racine.querySelector('[data-filtres]');
    var zoneFacettes = racine.querySelector('[data-facettes-zone]');
    var blocPastilles = racine.querySelector('[data-pastilles]');
    var listePastilles = racine.querySelector('[data-pastilles-liste]');
    var blocResultats = racine.querySelector('[data-resultats]');
    var selectTri = racine.querySelector('[data-tri-collection]');
    var blocPlus = racine.querySelector('[data-plus]');
    var boutonPlus = blocPlus && blocPlus.querySelector('[data-plus-bouton]');
    var infoPlus = blocPlus && blocPlus.querySelector('[data-plus-info]');
    var blocChargement = racine.querySelector('[data-chargement]');
    var bandeau = racine.querySelector('.coll-bandeau');
    if (bandeau) {
      var apres = bandeau;
      [blocPastilles, blocChargement].forEach(function (bloc) {
        if (bloc && bandeau.contains(bloc)) { apres.insertAdjacentElement('afterend', bloc); apres = bloc; }
      });
    }
    if (blocChargement) racine.appendChild(blocChargement);
    var videCollection = racine.querySelector('[data-vide-collection]');
    var videFiltre = racine.querySelector('[data-vide-filtre]');

    var etatURL = C.lireEtat(window.location.search);
    /* retour depuis une fiche produit : nombre de pièces affichées et position de défilement sont retrouvés */
    var sauve = window.history.state && window.history.state.mdmColl;
    if (sauve && sauve.q !== window.location.search) sauve = null;
    var etat = { sel: etatURL.sel, tri: etatURL.tri, affiche: sauve && sauve.affiche > 0 ? Math.min(sauve.affiche, 2000) : (cfg.lot || 48) };
    var interagi = false;
    var records = [];
    var parId = Object.create(null);
    var pagesEchouees = [];
    var charge = { total: Math.max(cfg.pages || 1, 1), faits: 0, enCours: false, fini: false };
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var minuterie = null;
    var rendu = null; /* dernier rendu : { cle: { grille, n } } pour l'ajout incrémental */
    var facettesUI = {};
    var ecouteurs = [];
    var ouvertes = []; /* facettes dépliées (ordinateur : une seule) */
    var feuilleOuverte = false;
    var versionRendu = 0;

    /* ---------------------------------------------------------------
       Enregistrements
       --------------------------------------------------------------- */
    function recordDepuisElement(carte, ordre, avecHtml) {
      var d = carte.dataset;
      return C.creerRecord({
        id: d.handle, pays: d.pays, valeur: d.valeur, qualite: d.qualite, millesime: d.millesime, type: d.type,
        titre: d.titre, cleTri: d.cleTri, prix: d.prix, date: d.date,
        html: avecHtml ? carte.outerHTML : '', el: avecHtml ? null : carte
      }, ordre);
    }
    function elementDe(r) {
      if (!r.el && r.produit) r.el = window.MDMCatalogueProduits.carte(r);
      if (!r.el) {
        var t = document.createElement('template');
        t.innerHTML = r.html;
        r.el = t.content.firstElementChild;
        r.html = '';
      }
      return r.el;
    }
    function ajouter(liste) {
      var neuf = 0;
      liste.forEach(function (r) {
        if (!r.id || parId[r.id]) return;
        parId[r.id] = r;
        records.push(r);
        neuf++;
      });
      return neuf;
    }
    var cartesInitiales = hote.querySelectorAll('[data-carte]');
    var decalage = ((cfg.page || 1) - 1) * 1000;
    ajouter(Array.prototype.map.call(cartesInitiales, function (c, i) { return recordDepuisElement(c, decalage + i, false); }));

    /* ---------------------------------------------------------------
       Chargement des autres pages (parallèle limité)
       --------------------------------------------------------------- */
    function urlPage(n) {
      var u = new URL(window.location.pathname, window.location.origin);
      u.searchParams.set('view', 'cartes');
      u.searchParams.set('page', String(n));
      return u.toString();
    }
    function lirePage(n, essai) {
      return fetch(urlPage(n), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cartes = doc.querySelectorAll('[data-carte]');
          return Array.prototype.map.call(cartes, function (c, i) { return recordDepuisElement(c, (n - 1) * 1000 + i, true); });
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') throw e;
          if (essai < 1) return lirePage(n, essai + 1);
          throw e;
        });
    }
    function chargerAutresPages(liste) {
      var file = liste.slice();
      var enCours = 0;
      charge.enCours = true;
      majChargement();
      return new Promise(function (resolve) {
        function suite() {
          while (enCours < (cfg.parallele || 4) && file.length) lancer(file.shift());
          if (!enCours && !file.length) resolve();
        }
        function lancer(n) {
          enCours++;
          lirePage(n, 0).then(function (rs) {
            ajouter(rs);
          }).catch(function (e) {
            if (!(e && e.name === 'AbortError')) pagesEchouees.push(n);
          }).then(function () {
            enCours--;
            charge.faits++;
            suite();
          });
        }
        suite();
      }).then(function () {
        charge.enCours = false;
        charge.fini = !pagesEchouees.length;
        majChargement();
        planifier(true);
        retrouverPosition();
      });
    }
    function demarrerChargement() {
      var api = window.MDMCatalogueProduits;
      if (api) {
        charge.enCours = true;
        var handle = decodeURIComponent(location.pathname.split('/collections/')[1] || 'all').split('/')[0];
        var tags = decodeURIComponent(location.pathname.split('/collections/')[1] || '').split('/')[1];
        return Promise.all([api.charger(), api.formes()]).then(function (donnees) {
          var rs = donnees[0].filter(function (r) {
            return (handle === 'all' || r.produit.collections.indexOf(handle) >= 0) && (!tags || tags.split('+').every(function (t) { return r.produit.tags.some(function (tag) { return tag.toLowerCase().replace(/[^a-z0-9]+/g, '-') === t.toLowerCase(); }); }));
          });
          if (rs.length !== cfg.total) throw new Error('Appartenance de collection incomplète');
          // Les cartes de la première page sont conservées, les autres restent de simples données.
          rs.forEach(function (r) { if (parId[r.id]) r.el = parId[r.id].el; });
          records = rs; parId = Object.create(null); rs.forEach(function (r) { parId[r.id] = r; });
          charge.enCours = false; charge.fini = true;
          planifier(true); retrouverPosition();
        }).catch(function () { return chargerPagesHTML(); });
      }
      return chargerPagesHTML();
    }
    function chargerPagesHTML() {
      var pages = [];
      for (var n = 1; n <= (cfg.pages || 1); n++) if (n !== (cfg.page || 1)) pages.push(n);
      charge.total = pages.length;
      charge.faits = 0;
      if (!pages.length) { charge.fini = true; return Promise.resolve(); }
      return chargerAutresPages(pages);
    }
    function reessayer() {
      var pages = pagesEchouees.slice();
      pagesEchouees = [];
      charge.total = pages.length;
      charge.faits = 0;
      chargerAutresPages(pages);
    }

    /* ---------------------------------------------------------------
       Indicateur de chargement
       --------------------------------------------------------------- */
    function majChargement() {
      if (!blocChargement) return;
      // Le chargement ne doit jamais ajouter une bande sous la barre de navigation.
      if (!pagesEchouees.length) { blocChargement.hidden = true; return; }
      var barre = blocChargement.querySelector('[data-chargement-barre]');
      var texte = blocChargement.querySelector('[data-chargement-texte]');
      var bouton = blocChargement.querySelector('[data-reessayer]');
      if (charge.enCours) {
        blocChargement.hidden = false;
        var total = Math.max(cfg.total || records.length, records.length);
        if (barre) barre.style.width = Math.min(100, Math.round(100 * records.length / Math.max(total, 1))) + '%';
        if (texte) texte.textContent = remplacer(lib.libChargement || 'Chargement… {n} sur {total}', { n: records.length, total: total });
        if (bouton) bouton.remove();
      } else if (pagesEchouees.length) {
        blocChargement.hidden = false;
        if (barre) barre.style.width = '100%';
        if (texte) texte.textContent = lib.libErreur || 'Certaines pièces n’ont pas pu être chargées.';
        if (!bouton) {
          bouton = el('button', 'coll-pastilles__tout', { type: 'button', 'data-reessayer': '' });
          bouton.textContent = lib.libReessayer || 'Réessayer';
          bouton.addEventListener('click', reessayer);
          blocChargement.appendChild(bouton);
        }
      } else {
        blocChargement.hidden = true;
      }
    }

    /* ---------------------------------------------------------------
       Planification des mises à jour (évite les rendus en rafale)
       --------------------------------------------------------------- */
    function planifier(maintenant) {
      if (maintenant) { clearTimeout(minuterie); minuterie = null; miseAJour(false); return; }
      if (minuterie) return;
      minuterie = setTimeout(function () { minuterie = null; miseAJour(false); }, 220);
    }
    function etatParDefaut() {
      return !C.nbFiltres(etat.sel) && C.estTriParDefaut(etat.tri);
    }
    function chargementEnCours() { return charge.enCours; }

    /* un seul passage : facettes, pastilles, résultats, grille */
    function miseAJour(ajoutSeul) {
      majChargement();
      majFacettes();
      majPastilles();
      /* tant que tout n'est pas chargé et que le visiteur n'a rien demandé : la page 1 reste telle que servie */
      if (chargementEnCours() && etatParDefaut() && !rendu) { majResultats(null); return; }
      rendreGrille(ajoutSeul);
    }

    /* ---------------------------------------------------------------
       Rendu de la grille (groupes d'années, sous-titres de type, grilles)
       --------------------------------------------------------------- */
    function nouvelleGrille() { return el('div', 'grille-produits'); }
    function titre(modele, texte, nombre) {
      if (!modele) return null;
      var n = modele.content.firstElementChild.cloneNode(true);
      var t = n.querySelector('[data-texte]');
      if (t) t.textContent = texte;
      var nb = n.querySelector('[data-nombre]');
      if (nb) nb.textContent = nombre == null ? '' : nombre;
      return n;
    }
    function texteResultat(n, total, filtre) {
      var modele = filtre ? lib.libResultatFiltre : (n > 1 ? lib.libResultatPl : lib.libResultatUn);
      return remplacer(modele || '{n}', { n: n, total: total });
    }
    function ancre() {
      var cartes = hote.querySelectorAll('[data-carte]');
      for (var i = 0; i < cartes.length; i++) {
        var b = cartes[i].getBoundingClientRect();
        if (b.bottom > 0) return { el: cartes[i], top: b.top };
      }
      return null;
    }
    function restaurerAncre(a) {
      if (!a || !a.el.isConnected) return;
      var d = a.el.getBoundingClientRect().top - a.top;
      if (Math.abs(d) > 1) window.scrollBy(0, d);
    }

    function rendreGrille(ajoutSeul) {
      var liste = C.filtrer(records, etat.sel);
      var parDefaut = C.estTriParDefaut(etat.tri);
      var triee = C.trier(liste, etat.tri, cfg.mode);
      var visibles = triee.slice(0, etat.affiche);
      var groupe = parDefaut && titresAnnee;
      var mode = groupe ? 'groupes' : 'plat';
      var filtreActif = C.nbFiltres(etat.sel) > 0;
      var nouveaux = [];

      /* nombre de pièces par année (sur toute la liste filtrée, pas seulement la partie affichée) */
      var nbAnnee = {};
      triee.forEach(function (r) { nbAnnee[r.annee] = (nbAnnee[r.annee] || 0) + 1; });

      function ajoutPlat(index) {
        var ex = index.plat;
        visibles.slice(ex.n).forEach(function (r) { var c = elementDe(r); ex.grille.appendChild(c); nouveaux.push(c); });
        ex.n = visibles.length;
      }
      function ajoutGroupes(index, parent) {
        C.grouper(visibles, sousTitres).forEach(function (a) {
          a.groupes.forEach(function (g) {
            var cle = a.annee + '|' + g.type;
            var ex = index[cle];
            if (ex) {
              g.items.slice(ex.n).forEach(function (r) { var c = elementDe(r); ex.grille.appendChild(c); nouveaux.push(c); });
              ex.n = g.items.length;
            } else {
              ajouterGroupe(a, g, cle, index, parent, nouveaux, nbAnnee[a.annee] || 0);
            }
          });
        });
      }

      if (ajoutSeul && rendu && rendu.mode === mode) {
        /* « Afficher plus » : la liste précédente est un préfixe de la nouvelle, on complète sans tout refaire */
        if (mode === 'plat') ajoutPlat(rendu.index); else ajoutGroupes(rendu.index, hote);
      } else {
        var garde = window.scrollY > 300 ? ancre() : null;
        var frag = document.createDocumentFragment();
        var index = {};
        if (mode === 'plat') {
          var grille = nouvelleGrille();
          frag.appendChild(grille);
          index.plat = { grille: grille, n: 0 };
          hote.replaceChildren(frag);
          ajoutPlat(index);
        } else {
          ajoutGroupes(index, frag);
          hote.replaceChildren(frag);
        }
        rendu = { mode: mode, index: index };
        restaurerAncre(garde);
        nouveaux = [];
      }

      if (window.mdmInitAjouts) window.mdmInitAjouts(hote);
      if (window.mdmDisponibilite) window.mdmDisponibilite.scan(hote);
      racine.classList.add('coll--pret');

      /* « Afficher plus » */
      var reste = triee.length - visibles.length;
      if (blocPlus) {
        blocPlus.hidden = reste <= 0;
        if (infoPlus && reste > 0) {
          infoPlus.textContent = remplacer(infoPlus.dataset.modele || '', { n: visibles.length, total: triee.length, reste: reste });
        }
      }

      /* états vides */
      if (videCollection) videCollection.hidden = records.length > 0 || cfg.total > 0;
      if (videFiltre) videFiltre.hidden = !(triee.length === 0 && records.length > 0 && !chargementEnCours());

      majResultats(triee.length, filtreActif);
      return nouveaux;
    }

    function ajouterGroupe(a, g, cle, index, parent, nouveaux, nbPieces) {
      var section = el('section', 'coll-groupe');
      section.setAttribute('data-annee', a.annee);
      if (!index['__a' + a.annee]) {
        index['__a' + a.annee] = true;
        var t = titre(modeleAnnee, a.annee ? String(a.annee) : (cfg.sansAnnee || ''), texteResultat(nbPieces, 0, false));
        if (t) section.appendChild(t);
      }
      if (sousTitres && g.type) {
        var ts = titre(modeleType, (cfg.types && cfg.types[g.type]) || g.type);
        if (ts) section.appendChild(ts);
      }
      var grille = nouvelleGrille();
      g.items.forEach(function (r) { var c = elementDe(r); grille.appendChild(c); if (nouveaux) nouveaux.push(c); });
      section.appendChild(grille);
      parent.appendChild(section);
      index[cle] = { grille: grille, n: g.items.length };
    }

    /* ---------------------------------------------------------------
       Résultats, pastilles
       --------------------------------------------------------------- */
    var dernierTexteResultat = '';
    function majResultats(n, filtre) {
      if (n == null) {
        var tous = Math.max(cfg.total || 0, records.length);
        n = tous; filtre = false;
      }
      var total = charge.fini || !charge.enCours ? Math.max(records.length, 0) : Math.max(cfg.total || 0, records.length);
      var texte = texteResultat(n, total, !!filtre);
      if (blocResultats && texte !== dernierTexteResultat) { blocResultats.textContent = texte; dernierTexteResultat = texte; }
      var voir = zoneFiltres && zoneFiltres.querySelector('[data-filtres-voir]');
      if (voir) voir.textContent = remplacer(lib.libVoir || '{n}', { n: n });
    }
    function libelleFacette(f) { return lib[NOMS_FACETTES[f]] || f; }
    function majPastilles() {
      var nb = C.nbFiltres(etat.sel);
      var badge = zoneFiltres && zoneFiltres.querySelector('[data-filtres-nb]');
      if (badge) { badge.hidden = !nb; badge.textContent = nb; }
      if (!blocPastilles || !listePastilles) return;
      blocPastilles.hidden = !nb;
      listePastilles.textContent = '';
      C.FACETTES.forEach(function (f) {
        if (etat.sel[f].size) {
          var li = el('li');
          var groupe = el('div', 'coll-pastille', { role: 'group', 'aria-label': libelleFacette(f) });
          var cat = el('span', 'coll-pastille__cat');
          cat.textContent = libelleFacette(f);
          groupe.appendChild(cat);
          var valeurs = el('span', 'coll-pastille__valeurs');
          etat.sel[f].forEach(function (libelle, cle) {
            if(valeurs.children.length)valeurs.appendChild(el('span','coll-pastille__virgule',{'aria-hidden':'true'})).textContent=',';
            var b=el('button','coll-pastille__retirer',{type:'button'});
            b.setAttribute('aria-label',remplacer(lib.libRetirer || 'Retirer le filtre {nom}',{nom:libelleFacette(f)+' : '+libelle}));
            var valeur=el('span','coll-pastille__valeur');valeur.textContent=libelle;b.appendChild(valeur);b.appendChild(svg('M2 2l6 6M8 2 2 8',10,10));
            b.addEventListener('click',function(){basculer(f,cle,libelle,false);});valeurs.appendChild(b);
          });
          groupe.appendChild(valeurs);
          li.appendChild(groupe);
          listePastilles.appendChild(li);
        }
      });
    }

    /* ---------------------------------------------------------------
       Facettes : construction et mise à jour sur place (le focus est conservé)
       --------------------------------------------------------------- */
    function construireFacettes() {
      if (!zoneFacettes || !outils) return;
      (outils.dataset.facettes || '').split(',').filter(Boolean).forEach(function (f) {
        var groupe = el('div', 'coll-facette');
        groupe.setAttribute('data-facette', f);
        var id = 'coll-f-' + f;
        var bouton = el('button', 'coll-facette__bouton', { type: 'button', 'aria-expanded': 'false', 'aria-controls': id });
        var t = el('span', 'coll-facette__titre');
        t.textContent = libelleFacette(f);
        var nb = el('span', 'coll-facette__nb');
        nb.hidden = true;
        bouton.appendChild(t);
        bouton.appendChild(nb);
        var chev = svg('M1 1l4.5 4.5L10 1', 11, 7, 'coll-facette__chevron');
        bouton.appendChild(chev);
        var panneau = el('div', 'coll-facette__panneau', { id: id, role: 'group', 'aria-label': libelleFacette(f) });
        panneau.hidden = true;
        var liste = el('ul', 'coll-facette__liste');
        panneau.appendChild(liste);
        groupe.appendChild(bouton);
        groupe.appendChild(panneau);
        zoneFacettes.appendChild(groupe);
        var ui = { f: f, groupe: groupe, bouton: bouton, nb: nb, panneau: panneau, liste: liste, items: new Map(), recherche: null, vide: null };
        facettesUI[f] = ui;
        /* Le même panneau au survol, au clic et au clavier ; tactile inchangé. */
        ecouter(groupe, 'pointerenter', function () {
          clearTimeout(ui.fermeture);
          if (!estMobile() && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
            if (ui.panneau.hidden) ui.ouvertSurvol = true;
            ouvrirPanneau(ui);
          }
        });
        function fermerApresSortie(e) {
          var pointeur = e && e.type === 'pointerleave';
          clearTimeout(ui.fermeture);
          if (estMobile()) return;
          ui.fermeture = setTimeout(function () {
            if (!groupe.matches(':hover') && (pointeur || !groupe.contains(document.activeElement))) fermerPanneau(ui, false);
          }, 180);
        }
        ecouter(groupe, 'pointerleave', fermerApresSortie);
        ecouter(groupe, 'focusout', fermerApresSortie);
        bouton.addEventListener('click', function () {
          /* Un clic après le survol conserve le panneau ouvert pour la sélection. */
          if (ui.ouvertSurvol) { ui.ouvertSurvol = false; ouvrirPanneau(ui); }
          else basculerPanneau(ui);
        });
        groupe.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !ui.panneau.hidden) { e.stopPropagation(); fermerPanneau(ui, true); }
        });
      });
    }
    function basculerPanneau(ui) {
      if (ui.panneau.hidden) ouvrirPanneau(ui); else fermerPanneau(ui, false);
    }
    function ouvrirPanneau(ui) {
      if (!estMobile()) Object.keys(facettesUI).forEach(function (k) { if (facettesUI[k] !== ui) fermerPanneau(facettesUI[k], false); });
      ui.panneau.hidden = false;
      ui.bouton.setAttribute('aria-expanded', 'true');
    }
    function fermerPanneau(ui, focus) {
      clearTimeout(ui.fermeture);
      ui.ouvertSurvol = false;
      if (ui.panneau.hidden) return;
      ui.panneau.hidden = true;
      ui.bouton.setAttribute('aria-expanded', 'false');
      if (focus) ui.bouton.focus();
    }
    function fermerTousPanneaux() {
      Object.keys(facettesUI).forEach(function (k) { fermerPanneau(facettesUI[k], false); });
    }

    function majFacettes() {
      var opts = C.calculerFacettes(records, etat.sel);
      var avecCompteurs = !outils || outils.dataset.compteurs !== '0';
      Object.keys(facettesUI).forEach(function (f) {
        var ui = facettesUI[f];
        var options = opts[f];
        var nbSel = etat.sel[f].size;
        ui.groupe.hidden = options.length < 2 && !nbSel;
        ui.groupe.classList.toggle('coll-facette--actif', nbSel > 0);
        ui.nb.hidden = !nbSel;
        ui.nb.textContent = nbSel;

        /* options : création / réutilisation / ordre, sans détruire l'élément ayant le focus */
        var vus = new Set();
        var precedent = null;
        options.forEach(function (o) {
          vus.add(o.cle);
          var it = ui.items.get(o.cle);
          if (!it) {
            var li = el('li');
            var label = el('label', 'coll-option');
            var input = el('input', null, { type: 'checkbox' });
            input.value = o.cle;
            var caseEl = el('span', 'coll-option__case');
            var txt = el('span', 'coll-option__lib');
            var cpt = el('span', 'coll-option__nb');
            label.appendChild(input); label.appendChild(caseEl); label.appendChild(txt); label.appendChild(cpt);
            li.appendChild(label);
            input.addEventListener('change', function () { basculer(f, o.cle, ui.items.get(o.cle).libelle, input.checked); });
            it = { li: li, input: input, txt: txt, cpt: cpt, label: label, libelle: o.libelle };
            ui.items.set(o.cle, it);
          }
          it.libelle = o.libelle;
          if (it.txt.textContent !== o.libelle) it.txt.textContent = o.libelle;
          it.input.checked = o.selectionne;
          var vide = o.compte === 0 && !o.selectionne;
          it.input.disabled = vide;
          it.label.classList.toggle('coll-option--vide', vide);
          var t = avecCompteurs ? String(o.compte) : '';
          if (it.cpt.textContent !== t) it.cpt.textContent = t;
          var attendu = precedent ? precedent.nextSibling : ui.liste.firstChild;
          if (it.li !== attendu) ui.liste.insertBefore(it.li, attendu);
          precedent = it.li;
        });
        ui.items.forEach(function (it, cle) {
          if (!vus.has(cle)) { it.li.remove(); ui.items.delete(cle); }
        });

        /* champ de recherche pour les listes longues */
        if (options.length > 8 && !ui.recherche) {
          var champ = el('input', 'coll-facette__recherche', { type: 'search', 'aria-label': libelleFacette(f), placeholder: lib.libRecherche || '', autocomplete: 'off' });
          champ.addEventListener('input', function () { filtrerOptions(ui, champ.value); });
          ui.panneau.insertBefore(champ, ui.liste);
          ui.recherche = champ;
        }
        if (ui.recherche) filtrerOptions(ui, ui.recherche.value);
      });
    }
    function filtrerOptions(ui, texte) {
      var t = C.sansAccent(texte);
      ui.items.forEach(function (it) {
        it.li.hidden = !!t && C.sansAccent(it.libelle).indexOf(t) < 0;
      });
    }

    /* ---------------------------------------------------------------
       Actions
       --------------------------------------------------------------- */
    function basculer(f, cle, libelle, actif) {
      if (actif) etat.sel[f].set(cle, libelle); else etat.sel[f].delete(cle);
      appliquer();
    }
    function toutEffacer() {
      C.FACETTES.forEach(function (f) { etat.sel[f].clear(); });
      appliquer();
    }
    function appliquer() {
      etat.affiche = cfg.lot || 48;
      ecrireURL();
      miseAJour(false);
    }
    function ecrireURL() {
      try {
        var q = C.ecrireEtat(window.location.search, etat.sel, etat.tri);
        window.history.replaceState(window.history.state, '', window.location.pathname + q + window.location.hash);
      } catch (e) { /* URL non modifiable : sans conséquence */ }
    }
    function afficherPlus() {
      var avant = etat.affiche;
      etat.affiche += cfg.lot || 48;
      var nouveaux = rendreGrille(true);
      if (nouveaux && nouveaux.length) {
        /* le focus passe à la première nouvelle carte (le bouton peut disparaître) */
        var lien = nouveaux[0].querySelector('.carte__titre');
        if (lien) lien.focus({ preventScroll: true });
      }
      return avant;
    }

    /* ---------------------------------------------------------------
       Feuille de filtres (mobile)
       --------------------------------------------------------------- */
    var feuille = zoneFiltres && zoneFiltres.querySelector('[data-filtres-feuille]');
    var fond = zoneFiltres && zoneFiltres.querySelector('[data-filtres-fond]');
    var boutonOuvrir = zoneFiltres && zoneFiltres.querySelector('[data-filtres-ouvrir]');
    function focalisables() {
      return Array.prototype.filter.call(feuille.querySelectorAll('button, input:not([disabled]), [href]'), function (n) {
        return !n.closest('[hidden]') && n.offsetParent !== null;
      });
    }
    function ouvrirFeuille() {
      if (!feuille || feuilleOuverte) return;
      feuilleOuverte = true;
      fond.hidden = false;
      feuille.setAttribute('role', 'dialog');
      feuille.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('coll-feuille-ouverte');
      boutonOuvrir.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        if (!feuilleOuverte) return;
        zoneFiltres.classList.add('coll-filtres--ouvert');
        var f = feuille.querySelector('[data-filtres-fermer]');
        if (f) f.focus();
      });
    }
    function fermerFeuille(rendreFocus) {
      if (!feuilleOuverte) return;
      feuilleOuverte = false;
      zoneFiltres.classList.remove('coll-filtres--ouvert');
      document.documentElement.classList.remove('coll-feuille-ouverte');
      feuille.setAttribute('role', 'group');
      feuille.removeAttribute('aria-modal');
      boutonOuvrir.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!feuilleOuverte) fond.hidden = true; }, 380);
      if (rendreFocus !== false) boutonOuvrir.focus();
    }
    function clavierFeuille(e) {
      if (!feuilleOuverte) return;
      if (e.key === 'Escape') { e.preventDefault(); fermerFeuille(); return; }
      if (e.key !== 'Tab') return;
      var f = focalisables();
      if (!f.length) return;
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }

    /* ---------------------------------------------------------------
       Écouteurs
       --------------------------------------------------------------- */
    function ecouter(cible, type, fn) {
      cible.addEventListener(type, fn);
      ecouteurs.push([cible, type, fn]);
    }
    function lier() {
      racine.querySelectorAll('[data-effacer-tout]').forEach(function (b) { ecouter(b, 'click', toutEffacer); });
      if (selectTri) {
        selectTri.value = etat.tri || 'manual';
        ecouter(selectTri, 'change', function () {
          etat.tri = selectTri.value === 'manual' ? '' : selectTri.value;
          appliquer();
        });
      }
      if (boutonPlus) ecouter(boutonPlus, 'click', afficherPlus);
      if (feuille) {
        ecouter(boutonOuvrir, 'click', ouvrirFeuille);
        ecouter(zoneFiltres.querySelector('[data-filtres-fermer]'), 'click', function () { fermerFeuille(); });
        ecouter(fond, 'click', function () { fermerFeuille(); });
        ecouter(zoneFiltres.querySelector('[data-filtres-voir]'), 'click', function () { fermerFeuille(); });
        ecouter(document, 'keydown', clavierFeuille);
      }
      /* clic en dehors d'une liste déroulante (ordinateur) */
      ecouter(document, 'pointerdown', function (e) {
        if (estMobile()) return;
        Object.keys(facettesUI).forEach(function (k) {
          var ui = facettesUI[k];
          if (!ui.panneau.hidden && !ui.groupe.contains(e.target)) fermerPanneau(ui, false);
        });
      });
      ecouter(window, 'resize', function () {
        if (feuilleOuverte && !estMobile()) fermerFeuille(false);
        calerBarre();
      });
      ecouter(window, 'pagehide', memoriser);
      ['pointerdown', 'wheel', 'keydown', 'touchstart'].forEach(function (t) {
        ecouter(window, t, function () { interagi = true; });
      });
    }
    function memoriser() {
      try {
        window.history.replaceState(Object.assign({}, window.history.state, { mdmColl: { affiche: etat.affiche, y: Math.round(window.scrollY), q: window.location.search } }), '');
      } catch (e) { /* sans conséquence */ }
    }
    function retrouverPosition() {
      if (!sauve || interagi || !(sauve.y > 0)) return;
      var y = sauve.y;
      sauve = null;
      requestAnimationFrame(function () { window.scrollTo(0, y); });
    }
    /* barre collante : se cale sous l'en-tête du site */
    function calerBarre() {
      var entete = document.querySelector('.header');
      if (entete) racine.style.setProperty('--coll-haut', Math.round(entete.getBoundingClientRect().height) + 'px');
    }

    /* ---------------------------------------------------------------
       Démarrage
       --------------------------------------------------------------- */
    this.dispose = function () {
      if (ctrl) ctrl.abort();
      clearTimeout(minuterie);
      Object.keys(facettesUI).forEach(function (k) { clearTimeout(facettesUI[k].fermeture); });
      ecouteurs.forEach(function (x) { x[0].removeEventListener(x[1], x[2]); });
      document.documentElement.classList.remove('coll-feuille-ouverte');
    };

    construireFacettes();
    lier();
    calerBarre();
    racine.classList.add('coll--actif');
    var multiPage = (cfg.pages || 1) > 1;
    if (window.MDMCatalogueProduits) {
      charge.enCours = true;
      racine.setAttribute('aria-busy', 'true');
      if (zoneFacettes) zoneFacettes.setAttribute('inert', '');
      if (selectTri) selectTri.disabled = true;
      // La première page ne se réorganise pas à chaque lot reçu.
      demarrerChargement().then(function () {
        racine.setAttribute('aria-busy', 'false');
        if (zoneFacettes) zoneFacettes.removeAttribute('inert');
        if (selectTri) selectTri.disabled = false;
      });
    } else if (multiPage) {
      if ('scrollRestoration' in window.history && sauve) window.history.scrollRestoration = 'manual';
      /* page utilisable tout de suite ; le chargement complet suit en tâche de fond */
      if (!etatParDefaut()) rendreGrille(false);
      else racine.classList.add('coll--pret');
      majFacettes();
      majPastilles();
      majResultats(null);
      demarrerChargement();
    } else {
      charge.fini = true;
      miseAJour(false);
      retrouverPosition();
    }
  }

  function initialiser(zone) {
    (zone || document).querySelectorAll('[data-coll]').forEach(function (r) {
      if (r.__mdmColl) return;
      r.__mdmColl = new Collection(r);
    });
  }

  initialiser(document);
  document.addEventListener('shopify:section:load', function (e) { initialiser(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-coll]').forEach(function (r) { if (r.__mdmColl && r.__mdmColl.dispose) r.__mdmColl.dispose(); });
  });
})();
